
























import Vue from 'vue'
import style from './style.module.scss'

// import quantity from './quantity.vue'

import { ProductMainInfo } from '@/types/supplier-search'

export default Vue.extend({
    name: 'product-info',
    components: {
        // quantity
    },
    props: {
        info: Object as () => ProductMainInfo
    },
    data() {
        return {
            style: style,
            isStable: process.env.VUE_APP_IS_STABLE === 'true'
        }
    },
    computed: {
        taxValue(): string {
            return parseFloat((((this.info.Price / (1 + this.info.TaxPercent / 100)) - this.info.Price) * -1)
                .toFixed(2))
                .toLocaleString('ru')
        }
    }
})
